import { AccountEffects } from './account.effects';
import { RouterEffects } from './router.effects';
import { AdOrderDraftEffects } from './ad-order-draft.effects';
import { AccountNotificationsEffects } from './notifications.effects';
import { AccountOrganizationEffects } from './account-organization.effects';
import { StatisticsEffects } from './statistics.effects';
import { MyPlatformsEffects } from './my-platforms.effects';


export const AllEffects = [
  AccountEffects,
  AccountOrganizationEffects,
  AdOrderDraftEffects,
  AccountNotificationsEffects,
  RouterEffects,
  StatisticsEffects,
  MyPlatformsEffects,
];
